import axios from 'axios';

import Session from 'shared_modules/Session';

export interface CancelPreauthRequest {
  paymentId: string;
  cancelReason?: string;
}

export interface CancelPreauthResponse {
  Payment: {
    paymentID: string;
    status: string;
    [key: string]: any;
  };
}

/**
 * Cancels a pre-authorized payment using the Payment API
 *
 * The Cancel endpoint can work with or without a payload.
 * If no payload is sent, it will cancel the payment without a specific reason.
 * If a payload is sent, it must be a complete Payment object (not just cancelReason).
 * For simplicity, we send an empty request body.
 *
 * @param request - The cancel request containing paymentId
 * @returns Promise with the cancelled payment response
 */
export const cancelPreauth = async (
  request: CancelPreauthRequest
): Promise<CancelPreauthResponse> => {
  const accountId = Session.accountID();

  // Call the cancel endpoint with empty payload
  // The backend will handle the cancellation without requiring a cancelReason
  const response = await axios.post<CancelPreauthResponse>(
    `/API/V3/Account/${accountId}/Payment/${request.paymentId}/Cancel.json`,
    {}
  );

  return response.data;
};
